import { useEffect } from 'react'

import useLegalAgreements, { GuardedScope } from '../../../hooks/useLegalAgreements'
import { usePageUrl } from '../../pages'

const useLegalAgreementsGuard = (): void => {
  const { allowedScopes } = useLegalAgreements()
  const { navigate } = usePageUrl()

  useEffect(() => {
    const isCheckoutAllowed = allowedScopes.indexOf(GuardedScope.CHECKOUT) >= 0
    if (!isCheckoutAllowed) {
      navigate('/checkout/agreements')
    }
  }, [allowedScopes, navigate])
}

export default useLegalAgreementsGuard
